import { useZero } from "@rocicorp/zero/react";
import { nanoid } from "nanoid";
import { sharedMutators } from "../../shared/mutators";
import { useHasAccess } from "../hooks/useHasAccess";
import { navigate, routes, useCurrentUrl } from "../lib/urls";
import { Banner } from "./Banner";
import { Button } from "./Button";
import type { BranchData, CommitData } from "./Workflow";

type Props = {
  branch: BranchData;
  commit: CommitData;
};

export function HistoryBanner({ branch, commit }: Props) {
  const z = useZero();
  const { spaceId, workflowId } = useCurrentUrl(routes.space.workflow);
  const canRestore = useHasAccess(
    branch.name === "main" ? "space:push_live" : "space:write",
    spaceId
  );

  const handleRestore = () => {
    z.mutate(
      sharedMutators.restoreToCommit({
        branchId: branch.id,
        targetCommitId: commit.id,
        newCommitId: nanoid(12),
        chatId: nanoid(12),
        entryId: nanoid(12),
        restoredFromMessage: commit.message,
      })
    );
    navigate(routes.space.workflow, {
      spaceId,
      workflowId,
      branchId: branch.id,
      commitId: "",
    });
  };

  const handleGoToLatest = () => {
    navigate(routes.space.workflow, {
      spaceId,
      workflowId,
      branchId: branch.id,
      commitId: "",
    });
  };

  return (
    <Banner
      actions={
        <>
          <Button
            variant="secondary"
            icon="redo-2"
            onClick={handleGoToLatest}
          />
          {canRestore && <Button onClick={handleRestore}>Restore</Button>}
        </>
      }
    >
      This is a historical version of this workflow
    </Banner>
  );
}
